export default __webpack_public_path__ + "static/media/bonus-points.cf6a1592.png";